import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";

export const ThumbnailBox = styled(Box)(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  height: 250,
  width: "100%",
  maxWidth: 320,
  margin: "0 auto",
  borderRadius: 16,
  backgroundColor: "#e0e0e0",
  [theme.breakpoints.up("sm")]: {
    width: 320,
    margin: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
}));

export const ThumbnailPlaceholder = styled(Box)({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  borderRadius: "inherit",
  background:
    "linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 45%, #cfcfcf 100%)",
});

export const ThumbnailImg = styled("img")<{ $loaded?: boolean }>(
  ({ $loaded }) => ({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    opacity: $loaded ? 1 : 0,
    transition: "opacity 0.2s ease-out",
    borderRadius: 16,
  })
);

export const PlayRecordingButton = styled(Button)({
  position: "absolute",
  bottom: 16,
  left: "50%",
  transform: "translateX(-50%)",
  minWidth: 0,
  maxWidth: "calc(100% - 24px)",
  padding: "5px 12px",
  fontSize: 12.5,
  lineHeight: 1.2,
  fontWeight: 600,
  textTransform: "none",
  borderRadius: 10,
  backgroundColor: "rgba(0, 0, 0, 0.72)",
  color: "#fff",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
  border: "none",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.92)",
    color: "#1a1a1a",
  },
  "& .MuiButton-startIcon": {
    marginRight: "4px",
    marginLeft: "-2px",
    color: "inherit",
    "& svg": { fontSize: 16 },
  },
});
